import { TitleBar } from 'components/layout/questionnaire/TitleBar/TitleBar';
import { Main } from 'components/shared/layout/Main/Main';
import { ROUTE_QUESTIONNAIRES, ROUTE_QUESTIONNAIRES_FORM } from 'config/routes';
import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { relativePath } from 'utils/navigation/relativePath';
import { NotFoundView } from 'views/Errors/NotFound.view';
import { FormView } from 'views/Questionnaires/Form/Form.view';
import { useStyles } from 'views/Questionnaires/Questionnaires.styles';

export const QuestionnairesView: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TitleBar />
      <div className={classes.content}>
        <Main>
          <Routes>
            <Route
              path={relativePath(ROUTE_QUESTIONNAIRES_FORM, ROUTE_QUESTIONNAIRES)}
              element={<FormView />}
            />
            <Route path="*" element={<NotFoundView />} />
          </Routes>
        </Main>
      </div>
    </div>
  );
};
